export const isDict = obj => obj && obj.constructor === Object;
export const isArray = obj => obj && obj.constructor === Array;
export const isEmpty = obj => !obj || Object.keys(obj).length === 0;
export const isObject = obj => typeof obj === 'object' && obj !== null;
